import { RouteLocationNormalizedLoaded } from "vue-router";
import { Order } from "../../../domain/entities/order";
export const getOrderFromURL = (
  route: RouteLocationNormalizedLoaded
): Order => {
  const search =
    route.query.search?.toString() !== undefined
      ? route.query.search.toString()
      : "";
  const page = Number(route.query.page) || undefined;
  const pageDefault = Number(route.query.pageDefault) || undefined;
  const limit = Number(route.query.limit) || undefined;
  const orderBy = route.query.orderBy?.toString();
  const isAsc = route.query.order === "Asc" ? true : false;
  const firstDate = route.query.firstDate?.toString() || undefined;
  const lastDate = route.query.lastDate?.toString() || undefined;
  const type = route.query.type ? Number(route.query.type) : undefined;
  const typeCode = route.query.typeCode
    ? Number(route.query.typeCode)
    : undefined;


  return new Order(
    page,
    pageDefault,
    limit,
    search,
    orderBy,
    isAsc,
    firstDate,
    lastDate,
    type,
    typeCode,
  );
};
